import { Box, Button } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { FormProvider } from "react-hook-form";
import { useTranslate } from "src/locales";
import { usePageThreeForm } from "./hooks/usePageThreeForm";
import VitalSignsAndHistory from "./components/VitalSignsAndHistory";
import ReproductivePattern from "./components/ReproductivePattern";
import HistoryActionButtons from "./components/HistoryActionButtons";
import PageThreeColumns from "./page_three_columns";

const PageThree: React.FC = () => {
  const { formMethods, onSubmit } = usePageThreeForm();
  const { t } = useTranslate();

  return (
    <FormProvider {...formMethods}>
      <Box sx={{ paddingTop: "20px" }}>
        <Grid container spacing={2}>
          <Box
            sx={{
              border: "1px solid #DBDBDB",
              borderRadius: "4px",
              padding: "20px",
              width: "100%",
            }}
          >
            <form onSubmit={onSubmit}>
              <VitalSignsAndHistory />
              
              <Box sx={{ my: 4 }}>
                <ReproductivePattern />
              </Box>

              <Box sx={{ my: 4 }}>
                <HistoryActionButtons />
              </Box>

              <Box sx={{ mt: 4, textAlign: "right" }}>
                <Button 
                  type="submit" 
                  variant="contained" 
                  color="primary"
                  sx={{ borderRadius: "20px", textTransform: "none", px: 4 }}
                >
                  {t("buttons.save")}
                </Button>
              </Box>
            </form>
          </Box>
          <PageThreeColumns />
        </Grid>
      </Box>
    </FormProvider>
  );
};

export default PageThree;
